export default "__VITE_ASSET__aWeoKScH__"